import { useState, useEffect } from 'react';
import { useAngularContext } from 'AngularContext';
import { useCurrentUser } from 'FrontRoyalAngular';
import studentDashboardConfig from './studentDashboardConfig';
import { type StudentDashboardConfig } from './StudentDashboard.types';

export default function useStudentDashboardConfig() {
    const $injector = useAngularContext();
    // Most arguments that get passed into studentDashboardConfig are derived from the current user,
    // so we'll just use the useCurrentUser hook in order to find out when the user data changes and
    // re-run studentDashboardConfig accordingly.
    const currentUser = useCurrentUser();
    const [dashboardConfig, setDashboardConfig] = useState<StudentDashboardConfig | null>(null);

    useEffect(() => {
        const config = studentDashboardConfig($injector);
        if (config) setDashboardConfig(config);
    }, [$injector, currentUser, setDashboardConfig]);

    return dashboardConfig;
}
